var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { themeColors } from '@juvare/common-web-ui/JuvareTheme';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import { AccordionSummary, accordionSummaryClasses, styled } from '@mui/material';
import React from 'react';
export const StyledAccordionSummary = styled((_a) => {
    var { children } = _a, props = __rest(_a, ["children"]);
    return (React.createElement(AccordionSummary, Object.assign({}, props, { expandIcon: React.createElement(ExpandMoreIcon, null) }), children));
})({
    padding: '16px 22px',
    flexDirection: 'row-reverse',
    [`& .${accordionSummaryClasses.expandIconWrapper}`]: {
        color: themeColors.text.link,
    },
    [`& .${accordionSummaryClasses.expandIconWrapper}.${accordionSummaryClasses.expanded}`]: {
        transform: 'rotate(180deg)',
    },
    [`& .${accordionSummaryClasses.content}, & .${accordionSummaryClasses.content}.${accordionSummaryClasses.expanded}`]: {
        margin: '0 12px',
        marginLeft: '22px',
    },
});
